export type ApiHandler = (params?: any, ...args: any[]) => Promise<any>;

const apiRegistry: Record<string, ApiHandler> = {};

export function register(endpoints: Record<string, ApiHandler>): void {
  Object.assign(apiRegistry, endpoints);
}

export default apiRegistry;

